import React from 'react';
import { testimonials } from '../data/baseball';
export function Testimonials() {
  // Hidden until authentic BASEBALL READY reviews are added in data/baseball.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-263" data-mp="3fym7ekpgr24c">
      <div className="mx-auto max-w-6xl" data-id="element-264" data-mp="3azt3njzzaphd">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-265" data-mp="3ayqcdayqul0x">
          What <em className="text-red-700" data-id="element-266" data-mp="31zwc9am7fcim">coaches</em> say
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-267" data-mp="31yl6545adsoc">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-268" data-mp="2x2mkvpf98qs5">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-269" data-mp="2s3jgm773mol8">
                <span aria-hidden="true" data-id="element-270" data-mp="v8555k5bgowg">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-271" data-mp="qa3pl973n7pq">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-272" data-mp="h814jfcje0g9">
                <span className="font-semibold text-slate-900" data-id="element-273" data-mp="m62oe2hse3ss">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-274" data-mp="78aaferw1ngp"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}